import React from "react";
import { Form, Input, Button } from "antd";


const EmailPreviewForm = ({ showButton }) => {
    const onFinish = (values) => {
        console.log(values);
    };

    return (
        <Form
            onFinish={onFinish}
            style={{ border: "1px solid #ccc", padding: "10px" }}
        >
            <div style={{ fontWeight: "", marginBottom: "10px" }}>
                Hello Prospect Name*. <br></br>
                <p style={{ margin: '9px 0px' }}>Thank you for your recent inquiry about «Property Address». «Link to Unit Listing».</p>
                <span style={{ color: 'gray' }}>Custom Email Body</span>

            </div>
            <Form.Item name="body">
                <Input.TextArea
                    placeholder="Enter email body"
                    style={{ height: "100px" }}
                ></Input.TextArea>
            </Form.Item>
            {showButton && <Form.Item>
                <Button type="primary" htmlType="submit" style={{ padding: '25px', fontWeight: 'bolder', display: 'flex', alignItems: 'center' }}>
                    Tell Us About You
                </Button>
            </Form.Item>}
            <div style={{ marginBottom: "10px" }}>
                «Company/Portfolio Name» <br></br>
                «Vacancy Posting Contact Phone Number» <br></br>
                «Company/Portfolio Website»
            </div>
        </Form>
    );
};

export default EmailPreviewForm;
